import { render, staticRenderFns } from "./GprAccess.vue?vue&type=template&id=4f31f387"
import script from "./GprAccess.vue?vue&type=script&lang=js"
export * from "./GprAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports